module.exports = __webpack_public_path__ + "img/hand_cd.d71cad5e.png";